import { useLocation } from "react-router-dom";

import { useRoutePathPrefix } from "./use-route-path-prefix";

/**
 * Returns the pathname without the route path prefix.
 */
export function useRoutePathname(opts?: {
  /**
   * If `true`, the path prefix will not be added to the path.
   */
  includePathPrefix?: boolean;
}): string {
  const location = useLocation();
  const routingPathPrefix = useRoutePathPrefix();

  return opts?.includePathPrefix
    ? location.pathname
    : location.pathname.replace(routingPathPrefix, "");
}
